
export async function downloadSpentHoursExcel(params: {
  metaRows: [string, string][];
  columnHeaders: string[];
  dataRows: string[][];
  baseFilename: string;
}): Promise<void> {
  const ExcelJS = (await import("exceljs")).default;
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Spent Hours");

  params.metaRows.forEach(([left, right]) => {
    sheet.addRow([left, right]);
  });

  sheet.addRow(params.columnHeaders);
  const headerRowIndex = sheet.rowCount;
  const headerRow = sheet.getRow(headerRowIndex);
  headerRow.font = { bold: true };
  headerRow.alignment = { vertical: "middle" };

  const hoursColumnIndex = params.columnHeaders.findIndex(
    h => h.trim().toLowerCase() === "hours"
  );

  const parseDurationText = (value: string): number | null => {
    const raw = String(value ?? "").trim();
    const match = raw.match(/^(\d+):([0-5]?\d)$/);
    if (!match) {
      return null;
    }
    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    if (!Number.isFinite(hours) || !Number.isFinite(minutes)) {
      return null;
    }
    return (hours * 60 + minutes) / 1440;
  };

  params.dataRows.forEach(cells => {
    const row = sheet.addRow(cells);

    // Keep "Hours" as real Excel duration so SUM works correctly (no 24h wrap).
    if (hoursColumnIndex >= 0) {
      const excelColumn = hoursColumnIndex + 1;
      const duration = parseDurationText(String(cells[hoursColumnIndex] ?? ""));
      if (duration !== null) {
        row.getCell(excelColumn).value = duration;
        row.getCell(excelColumn).numFmt = "[h]:mm";
      }
      row.getCell(excelColumn).alignment = {
        vertical: "top",
        horizontal: "left",
        wrapText: false,
      };
    }
  });

  // Column widths (Excel units)
  const columnWidths = [12, 24, 24, 20, 16, 16, 20, 12, 16, 62];
  columnWidths.forEach((width, i) => {
    sheet.getColumn(i + 1).width = width;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${params.baseFilename}.xlsx`;
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}